import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const MissionOrderService = {

    async findMissionsOM() {
        try {
            const result = await axios.get(`${apiUrl}/MissionOrder/missionPlanningOM`);
            if (result) {
                return result.data;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
    },

    async filterMissionValidated(formData){
            try{
                const result = await axios.post(
            `${apiUrl}/MissionOrder/filterMissionValidated`,{
                filterData:formData
            });
                if (result) {
                    return result.data;
                }
            }
            catch(error){
                if(error.response){
                    return error.response.data;
                }
            }
    
        },

    async missionOrderGenerate(planning_id, agenda_id) {
        try {
            const result = await axios.get(`${apiUrl}/MissionOrder/getOMUser?mission_planning_id=${planning_id}&mission_planning_agenda_id=${agenda_id}`,
                {
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/pdf',
                    },
                });

            if (result) {
                return result;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
    },

    async sendUsersOM(planning_id_array) {
        console.log(planning_id_array);
        try {
            const result = await axios.post(`${apiUrl}/MissionOrder/sendUsersOM`, {
                mission_planning_ids: planning_id_array
            },);

            if (result) {
                return result;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
    },

    async driversMissionsPlanning() {
        try {
            const result = await axios.get(`${apiUrl}/MissionOrder/driversMissionsPlanning`);
            if (result) {
                return result.data;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
    },

    async generateOMDriver(mission_planning_id, driver_id, voiture_id, agenda_id) {
        console.log(mission_planning_id, driver_id, voiture_id);

        try {
            const result = await axios.post(
                `${apiUrl}/MissionOrder/missionOrderDriver`,
                {
                    mission_planning_id: mission_planning_id,
                    driver_id: driver_id,
                    voiture_id: voiture_id,
                    mission_planning_agenda_id: agenda_id
                },
                {
                    responseType: 'blob', // Pour recevoir une rÃ©ponse binaire (PDF)
                    headers: {
                        'Content-Type': 'application/json', // Correct pour les donnÃ©es JSON envoyÃ©es au backend
                    },
                }
            );
            

            if (result) {
                return result;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
    },

    async missionOrderAnnexeGenerate(planning_id) {
        try {
            const result = await axios.get(`${apiUrl}/MissionOrder/getAnnexe/${planning_id}`,
                {
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/pdf',
                    },
                });

            if (result) {
                return result;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
    },

    async downloadDriverOM(planning_id, agenda_id) {
        try {
            const result = await axios.post(
                `${apiUrl}/MissionOrder/downloadDriverOM`,
                {
                    mission_planning_id: planning_id,
                    mission_planning_agenda_id: agenda_id
                }
            );

            if (result) {
                return result.data;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
    },

}

export default MissionOrderService;
